module.exports = __webpack_public_path__ + "static/img/vip4.3b3b1563.png";